import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  Modal,
  LoaderIndicator,
  HelperViewStatus,
  HeadingDisplay,
  BaseText,
  ListDisplay,
  InitialAvatarIcon,
  ButtonContainer,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import {
  getPortfolioOrderDetails,
  IPortfolioOrderDetails,
  EButtonAction
} from '@/modules/home/services/orders';
import { WealthPortfolioTabs } from '@/modules/wealth/views/WealthPortfolioV2/types';

interface Props {
  isOpen: boolean;
  orderId: string;
  productType: string;
  portfolioType: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioOrderDetails',
  props: {
    isOpen: { type: Boolean },
    orderId: null,
    productType: null,
    portfolioType: null
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  orderId: string;
  productType: string;
  portfolioType: string;
};

const router = useRouter();



const orderDetails = ref<IPortfolioOrderDetails | null>(null);
const isLoading = ref(false);
const hasError = ref(false);
const cancelModalOpen = ref(false);

watch(
  () => props.isOpen,
  async isOpen => {
    if (isOpen) {
      fetchOrderDetails();
    }
  }
);

function handleClick(action: EButtonAction) {
  if (action === EButtonAction.OPEN_ORDER) {
    router.push({
      name: 'wealthPortfolio',
      params: {
        id: orderDetails.value!.portfolioId,
        type: props.portfolioType
      },
      query: {
        tab: WealthPortfolioTabs.Orders,
        orderId: props.orderId
      }
    });
  }
}

async function fetchOrderDetails() {
  try {
    isLoading.value = true;
    hasError.value = false;

    orderDetails.value = await getPortfolioOrderDetails(
      props.orderId,
      props.productType
    );
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,router, props, orderDetails, isLoading, hasError, cancelModalOpen, handleClick, fetchOrderDetails, Modal, LoaderIndicator, HelperViewStatus, HeadingDisplay, BaseText, ListDisplay, InitialAvatarIcon, ButtonContainer, ButtonSecondary, NebraskaColors }
}

})